import * as React from 'react';
import { path } from 'ramda';

import { IBaseQuestionProps } from '../FormContainer/types/internal';
import { IUseSimpleFormParams, useSimpleForm } from '../../utils/useSimpleForm';
import { FIOContainer } from '../FIOContainer';
import { fioValidator } from './utils/fioValidator';
import { FIOQuestion } from '../../components/FIOQuestion';
import { useFormTracking } from '../../utils/useFormTracking';

export const FioQuestionContainer: React.FC<React.PropsWithChildren<IBaseQuestionProps>> = props => {
  const {
    question: { answerField, title, required },
    setNextStep,
    setAnswersState,
    answersState,
  } = props;

  const { trackSubmit } = useFormTracking();

  /**
   * Хендлер вызывается при успешно пройденной валидации внутри хука useSimpleForm
   * Выполняет синхронизацию стейта из хука useSimpleForm с основным стейтом опросника
   * */
  const onSubmit = React.useCallback<IUseSimpleFormParams['onSubmit']>(
    values => {
      setAnswersState(prevState => {
        const nextState = { ...prevState };

        /** в values будет содержаться единственное значение под ключем {answerField} - name */
        nextState[answerField] = { answerField, value: String(values[answerField]) };

        setNextStep(nextState);

        trackSubmit({
          isRequired: required,
          value: null,
          field: 'fullName',
        });

        return nextState;
      });
    },
    [required, trackSubmit, setAnswersState, setNextStep, answerField],
  );

  const { handleChange, errors, handleSubmit, isFormValid } = useSimpleForm({
    validators: {
      [answerField]: fioValidator,
    },
    required,
    onSubmit,
  });

  const handleFIOChange = React.useCallback(
    (value: any) => handleChange(answerField, value.trim()),
    [handleChange, answerField],
  );

  return (
    <FIOQuestion
      title={title}
      error={errors[answerField]}
      nextBtnDisabled={!isFormValid}
      handleSubmit={handleSubmit}
      fioComponent={
        <FIOContainer
          onChange={handleFIOChange}
          initialValue={path([answerField, 'value'], answersState)}
          inputName={answerField}
        />
      }
    />
  );
};

FioQuestionContainer.displayName = 'FioQuestionContainer';
